(function(algolia) {
  'use strict';
  var aa = algolia.externals.aa;

  var enabled = algolia.config.analytics_enabled;
  if (!enabled) return;

  aa.init({
    appId: algolia.config.app_id,
    apiKey: algolia.config.search_api_key,
  });

  function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0)
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  }

  const localStorageKey = 'algolia_analytics_clicked_objects';
  
  function sendConversionEvent() {
     if(document.querySelector(".page--thank-you")) {
       var products = document.querySelectorAll(".product-table .product");
       var items = [];
       [].forEach.call(products, function(product) {
         items.push({
           product_id: product.dataset.productId,
           variant_id: product.dataset.variantId
         });
       });
       
       try {
         // Get any previously stored data.
         var previousClickItemsString = localStorage.getItem(localStorageKey);
         // If data was found, send a conversion event for those products.
         if (!!previousClickItemsString) {
           var previousClickItems = JSON.parse(previousClickItemsString);
           previousClickItems.forEach(function(item) {
             var hasItem = items.find(function(i) {
               return i.variant_id == item.variantID
             });
             if(hasItem) {
               hasItem.converted = true;
               delete item.positions;
               item.eventName = 'Product Purchased';
               aa.convertedObjectIDsAfterSearch(item);
             }
           });
         }

         var data = {
           index: Theme.settings.algolia.product_index,
           eventName: 'Product Purchased',
           objectIDs: [],
           userToken: window.Theme.settings.algolia.userToken,
         };

         items.forEach(function(item) {
           if(!item.converted) {
             data.objectIDs.push(item.variant_id);
           }
         });

         if(data.objectIDs.length) {
           aa.convertedObjectIDs(data);
         }
       } catch (error) {
         // No need to do anything in this scenario.
         console.error(error);
       }

       // Try to remove the items from local storage.
       try {
         localStorage.removeItem(localStorageKey);
       } catch (error) {
         // No need to do anything in this scenario.
       }
     }
  }
  
  function trackPLPView() {
    if(document.body.classList.contains("template-collection")) {
      const viewData = {
        index: Theme.settings.algolia.product_index,
        eventName: 'Landing Page Viewed',
        filters: ['category:' + encodeURIComponent(document.querySelector(".section-header__title").innerText)],
        userToken: window.Theme.settings.algolia.userToken,
      };

      aa.viewedFilters(viewData);
    }
  }
  
  $('body').on('afterAddItem.ajaxCart', function(e, line_item) {
    try {
      let previousClickItemsString = localStorage.getItem(localStorageKey);
      let previousItem;
      // If data was found, send a conversion event for those products.
      if (!!previousClickItemsString) {
        var previousClickItems = JSON.parse(previousClickItemsString);
        previousItem = previousClickItems.find((item) => {
          return item.objectIDs.some((id) => id = line_item.variant_id) || item.productId == line_item.product_id;
        });
      }

      var prefix = window.location.pathname.startsWith('/products/') ? 'PDP: ' : 'PLP: ';

      if(previousItem) {
        delete previousItem.positions;
        previousItem.eventName = prefix + 'Product Added to Cart';
        aa.convertedObjectIDsAfterSearch(previousItem);
      } else {
        var clickData = {
          index: Theme.settings.algolia.product_index,
          eventName: prefix + 'Product Added to Cart',
          objectIDs: [String(line_item.variant_id)],
          userToken: window.Theme.settings.algolia.userToken,
        };

        aa.convertedObjectIDs(clickData);
      }
    } catch (err) {
    	console.error(err);
    }
  });
  
  function trackAnalytics() {
    sendConversionEvent();
    trackPLPView();
  }
  
  function setupUserToken() {
    let userToken = window.Theme.settings.algolia.userToken;
    aa.setUserToken(userToken);
    trackAnalytics();
  }
  setupUserToken();

  /**
   * Saves details in local storage for conversion tracking
   */
  algolia.saveForConversionTracking = function (data) {
    /**
     * We're using a try, catch here to handle any possible exceptions
     * resulting from local storage or JSON parsing.
     */
    try {
      // Get any data previously stored
      const previousClickItemsString = localStorage.getItem(localStorageKey) || '[]';
      const previousClickItems = JSON.parse(previousClickItemsString);

      var conversionData = data;

      // Changing the event to 'convert' from 'click'
      conversionData.eventName = 'convert';
      // Removing the `positions` property
      delete conversionData.positions;

      // Add the current products data to local storage
      previousClickItems.unshift(conversionData);
      localStorage.setItem(localStorageKey, JSON.stringify(previousClickItems))
    } catch (error) {
      // No need to do anything in this scenario
    }
  };
})(window.algoliaShopify);
